<template>
  <overlay id="ContentFilterOverlay">
    <page class="content-filter">
      <div class="content-filter__header">
        <div class="content-filter__foldername">{{ folder.name }}</div>
        <h1
          v-t="'c.contentFilterOverlay.title'"
          class="content-filter__headline"
        />
      </div>

      <content-filter-form />
    </page>
  </overlay>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import PageMixin from '@/mixins/pages/Page'
import Overlay from '@/components/ui/Overlay'
import ContentFilterForm from '@/components/contents/ContentFilterForm'

export default {
  name: 'ContentFilterOverlay',
  mixins: [PageMixin],
  components: {
    Overlay,
    ContentFilterForm
  },
  computed: {
    ...mapState({
      folder: state => state.folder.folder
    }),
  },
  methods: {
    ...mapActions([
      'openOverlay',
      'closeOverlay'
    ])
  }
}
</script>

<style lang="sass">
@import "~styles/imports"

.content-filter
  &__header
    text-align: center

  &__foldername
    +font-size(14, 20)
    color: $color-grey-2

  &__headline
    +font-size(48, 48)
    margin-top: rem-calc(15)

</style>



// WEBPACK FOOTER //
// src/components/contents/ContentFilterOverlay.vue